import React from 'react';
import MainHeader from './MainHeader';

const PageWrapper = ({ title, children }) => {
  return (
    <div className="min-h-screen bg-black">
      {/* Page Title - Outside the border */}
      <div className="bg-black py-6">
        <div className="text-center">
          <h1 className="text-white text-2xl font-bold tracking-wider font-avenir">
            {title}
          </h1>
        </div>
      </div>
      
      {/* Page Content with Border */}
      <div className="px-4 pb-4 bg-black">
        <div className="border-2 border-white  min-h-[calc(100vh-120px)]">
          {/* Main Header */}
           
             <MainHeader />
          
          {/* Page Content */}
          <div className="px-4 pb-4 bg-[#141414]">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageWrapper;
